import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { AxiosError } from 'axios';

export const fetchBusinessProfile = async (query) => {
  const { data } = await apiClient.get(`/business-profiles/${query.queryKey[1]}`);
  return data;
};

export const useGetBusinessProfileHandler = (id) => {
  const dispatch = useDispatch();
  const [businessProfile, setBusinessProfile] = useState(undefined);

  const {
    data: fetchedData,
    isLoading,
    isFetching,
    isError,
    error,
  } = useQuery({
    queryKey: ['business_profiles', id], // A unique key for this query
    queryFn: fetchBusinessProfile,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
    cacheTime: 0,
    retry: 3,
  });

  useEffect(() => {
    if (fetchedData) {
      setBusinessProfile(fetchedData);
    }
  }, [fetchedData]);

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        if (error.status) {
          dispatch(showSnackbar({ message: error.response.data.message, severity: 'error' }));
        } else {
          dispatch(showSnackbar({ message: error.message, severity: 'error' }));
        }
      } else {
        dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
      }
    }
  }, [dispatch, error, isError]);

  return {
    businessProfile,
    isLoading,
  };
};
